import { find } from 'lodash';

import type { UrlTypeChoicesResponse } from '@api/urls/api.urls.types';

export const getLinkTypeDisplayValue = (
  link?: { url_type?: string },
  linkTypes?: UrlTypeChoicesResponse,
): string => {
  if (!link?.url_type || !linkTypes?.url_type) return '';
  const linkType = find(linkTypes.url_type, ['value', link.url_type]);
  return linkType?.display_name ?? '';
};
